import { memo, type RefObject, useCallback } from 'react';

import { WorkspaceAgentMentionListSentinel } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/mentions/WorkspaceAgentMentionListSentinel';

export type WorkspaceAgentMentionNodeSentinelProps = {
  isFetching: boolean;
  listRef: RefObject<HTMLElement | null>;
  nodeId: string;
  onFetchNextPageForNode: (nodeId: string) => void;
  rootMargin: string;
};

export const WorkspaceAgentMentionNodeSentinel = memo(
  ({ isFetching, listRef, nodeId, onFetchNextPageForNode, rootMargin }: WorkspaceAgentMentionNodeSentinelProps) => {
    const handleFetch = useCallback(() => {
      onFetchNextPageForNode(nodeId);
    }, [nodeId, onFetchNextPageForNode]);

    return (
      <WorkspaceAgentMentionListSentinel
        isFetching={isFetching}
        listRef={listRef}
        onFetch={handleFetch}
        rootMargin={rootMargin}
      />
    );
  },
);

WorkspaceAgentMentionNodeSentinel.displayName = 'WorkspaceAgentMentionNodeSentinel';
